/**
 * Arabic for facility inspections — the screen, its forms and reports, and the
 * catalogues the forms are built from: the seven trades, their checklist items
 * and repair types. Proposed; pending native review by the trades.
 */
const ar: Record<string, string> = {
  /* ── the screen ── */
  "Facility inspections": "فحص المرافق",
  "New daily inspection": "فحص يومي جديد",
  "New detailed inspection": "فحص تفصيلي جديد",
  "Each trade inspects the facilities it looks after, through its own contractor: a short daily round, and a detailed inspection. A defect found becomes a work order in the same register Operations control works from.":
    "يفحص كل تخصص المرافق التي يتولاها عبر مقاوله: جولة يومية قصيرة، وفحص تفصيلي. وأي عيب يُكتشف يصبح أمر عمل في السجل نفسه الذي يعمل منه مركز التحكم بالعمليات.",
  "{n} inspections and repairs shown here are sample records, marked as such in every report.":
    "{n} من الفحوصات والإصلاحات المعروضة هنا سجلات نموذجية، ومُعلَّمة كذلك في كل تقرير.",
  "Remove every sample inspection and repair? Records you entered stay.":
    "حذف كل الفحوصات والإصلاحات النموذجية؟ تبقى السجلات التي أدخلتها.",
  "Remove the sample": "حذف البيانات النموذجية",
  Viewing: "العرض",
  "All trades": "كل التخصصات",
  "critical findings open": "ملاحظات حرجة مفتوحة",
  "major findings open": "ملاحظات كبيرة مفتوحة",
  "findings with no work order": "ملاحظات بلا أمر عمل",
  "work orders from inspections open": "أوامر عمل مفتوحة من الفحوصات",
  "inspections, last 30 days": "فحوصات، آخر 30 يومًا",
  "forecast, next 12 months": "التوقع، الأشهر الـ12 القادمة",
  "Condition by facility and trade": "الحالة حسب المرفق والتخصص",
  "Read from each trade's latest detailed inspection; ▲▼ is the change since the one before.":
    "مأخوذة من آخر فحص تفصيلي لكل تخصص؛ ▲▼ هو التغير منذ الفحص السابق.",
  "All groups": "كل المجموعات",
  Facility: "المرفق",
  Group: "المجموعة",
  criticality: "الأهمية",
  Detailed: "تفصيلي",
  "Last: {form} on {date} by {company}": "الأخير: {form} في {date} بواسطة {company}",
  "Never inspected by this trade.": "لم يفحصه هذا التخصص قط.",
  "Inspection history": "سجل الفحوصات",
  "No inspections recorded.": "لا فحوصات مسجلة.",
  Trade: "التخصص",
  Company: "الشركة",
  Defects: "العيوب",
  "Work orders on this facility": "أوامر العمل على هذا المرفق",
  "Every item OK.": "كل البنود سليمة.",
  "Nothing open.": "لا شيء مفتوح.",
  "A work order was not raised: {why}": "لم يُنشأ أمر العمل: {why}",
  "Grouped by facility and trade, worst first; create a new work order from any of them.":
    "مجمعة حسب المرفق والتخصص، الأسوأ أولًا؛ أنشئ أمر عمل من أي منها.",
  "Nothing open at this severity.": "لا شيء مفتوح بهذه الدرجة.",
  "Work orders raised from inspections": "أوامر العمل الناشئة عن الفحوصات",
  "The same orders as on the work-orders board: a status changed here is changed there.":
    "هي الأوامر نفسها في لوحة أوامر العمل: أي حالة تتغير هنا تتغير هناك.",
  "No work orders raised from inspections yet.": "لم تُنشأ أوامر عمل من الفحوصات بعد.",
  "Changed from facility inspections": "غُيّر من فحص المرافق",
  "Held from facility inspections": "أُوقف من فحص المرافق",
  "Show closed": "إظهار المغلقة",
  "Change status": "تغيير الحالة",
  "Cost, SAR": "التكلفة، ريال",
  "Actual cost, SAR, for {number}": "التكلفة الفعلية بالريال لـ {number}",
  "Only legal moves are offered; the platform has the final word, and a refusal is shown as it worded it. A cost entered on completion feeds the history and the forecast.":
    "لا تُعرض إلا الانتقالات المسموح بها؛ والكلمة الأخيرة للمنصة، ويُعرض الرفض بصياغتها. والتكلفة المُدخلة عند الإنجاز تغذي السجل والتوقع.",
  "Repairs year on year": "الإصلاحات سنة بسنة",
  "Count and cost of repairs opened each year, by trade{sample}.": "عدد وتكلفة الإصلاحات المفتوحة كل سنة، حسب التخصص{sample}.",
  " — includes sample records": " — تشمل سجلات نموذجية",
  "(to date)": "(حتى الآن)",
  "Average cost": "متوسط التكلفة",
  "Types of repair": "أنواع الإصلاح",
  "Most frequent first, with what they cost.": "الأكثر تكرارًا أولًا، مع تكلفتها.",
  avg: "متوسط",
  "Condition compared": "مقارنة الحالة",
  "Latest detailed inspection against the one before — the largest falls first.":
    "آخر فحص تفصيلي مقابل السابق — أكبر التراجعات أولًا.",
  "Next 12 months: {total}": "الأشهر الـ12 القادمة: {total}",
  "Expected repairs and the open findings still to put right, costed at what repairs have cost.":
    "الإصلاحات المتوقعة والملاحظات المفتوحة التي لم تُعالج بعد، مُسعَّرة بما كلفته الإصلاحات.",
  "How it is worked out": "طريقة الحساب",
  "Rate: the repairs of the last two years, halved, per facility and trade.":
    "المعدل: إصلاحات آخر سنتين مقسومة على اثنين، لكل مرفق وتخصص.",
  "Condition factor, from the latest detailed inspection: {factors}. Proposed, not calibrated.":
    "معامل الحالة، من آخر فحص تفصيلي: {factors}. مقترح، غير معايَر.",
  "Open findings with no work order count as part of a repair: critical {c}, major {m}, minor {n}.":
    "الملاحظات المفتوحة بلا أمر عمل تُحسب جزءًا من إصلاح: حرجة {c}، كبيرة {m}، بسيطة {n}.",
  "Cost: the facility and trade's own average when it has three costed repairs, else the trade's average.":
    "التكلفة: متوسط المرفق والتخصص نفسه إن وُجدت له ثلاثة إصلاحات مُسعَّرة، وإلا متوسط التخصص.",
  "Where the money is forecast to go": "أين يُتوقع أن يُنفق المال",
  "Highest first.": "الأعلى أولًا.",
  "Repairs, 2 years": "الإصلاحات، سنتان",
  "this facility's own average": "متوسط هذا المرفق نفسه",
  "the trade's average": "متوسط التخصص",
  "a proposed typical cost": "تكلفة نموذجية مقترحة",
  "{n} repair expected|{n} repairs expected":
    "لا إصلاحات متوقعة|إصلاح واحد متوقع|إصلاحان متوقعان|{n} إصلاحات متوقعة|{n} إصلاحًا متوقعًا|{n} إصلاح متوقع",
  "Who inspects what": "من يفحص ماذا",
  "One contractor per trade, linked to its contract in the stakeholders' register when there is one.":
    "مقاول واحد لكل تخصص، مربوط بعقده في سجل الجهات المعنية إن وُجد.",
  Contact: "جهة الاتصال",
  "No contract linked": "لا عقد مربوط",
  "Save the contractors": "حفظ المقاولين",
  "Open the contracts register": "فتح سجل العقود",
  "Facility inspections views": "طرق عرض فحص المرافق",
  "Findings and work orders": "الملاحظات وأوامر العمل",
  "History and comparison": "السجل والمقارنة",
  Contractors: "المقاولون",
  Reports: "التقارير",
  "Major and critical": "الكبيرة والحرجة",
  Hold: "إيقاف مؤقت",

  /* ── the form ── */
  "Name the inspector and the company before saving.": "اذكر اسم المفتش والشركة قبل الحفظ.",
  "Inspection saved": "حُفظ الفحص",
  "Condition {score} — {band}.": "الحالة {score} — {band}.",
  "Nothing found to repair.": "لم يُعثر على ما يحتاج إصلاحًا.",
  "Work order {number}": "أمر العمل {number}",
  "New Work Orders for every defect": "أوامر عمل جديدة لكل العيوب",
  "New Work Orders for all {n}": "أوامر عمل جديدة للكل ({n})",
  "They join the work-orders register that Operations control works from.":
    "تنضم إلى سجل أوامر العمل الذي يعمل منه مركز التحكم بالعمليات.",
  "Every item starts OK — mark only what is not.": "كل بند يبدأ سليمًا — علّم فقط ما ليس كذلك.",
  "Daily inspection — short form": "فحص يومي — النموذج القصير",
  "Detailed inspection — full form": "فحص تفصيلي — النموذج الكامل",
  "Date and time": "التاريخ والوقت",
  Remarks: "ملاحظات",
  "What was found": "ما الذي وُجد",
  "Repair needed": "الإصلاح المطلوب",
  "Repair needed…": "الإصلاح المطلوب…",
  "Condition {score} — {band}": "الحالة {score} — {band}",
  "{n} defect found.|{n} defects found.":
    "لم يُعثر على عيوب.|عُثر على عيب واحد.|عُثر على عيبين.|عُثر على {n} عيوب.|عُثر على {n} عيبًا.|عُثر على {n} عيب.",
  "{n} defect|{n} defects": "لا عيوب|عيب واحد|عيبان|{n} عيوب|{n} عيبًا|{n} عيب",

  /* ── reports ── */
  "All facilities": "كل المرافق",
  "Short report — condition summary": "تقرير قصير — ملخص الحالة",
  "Long report — findings, inspections and repairs": "تقرير مطول — الملاحظات والفحوصات والإصلاحات",
  "Print or save as PDF": "طباعة أو حفظ PDF",
  "Facility condition report": "تقرير حالة المرافق",
  "Facility inspection report — detailed": "تقرير فحص المرافق — مفصل",
  "Prepared {when} by {who}": "أُعدّ في {when} بواسطة {who}",
  "includes sample records": "يشمل سجلات نموذجية",
  "Nothing has been inspected or repaired in this scope yet.": "لم يُفحص أو يُصلح شيء في هذا النطاق بعد.",
  "facility and trade lines": "سطور المرافق والتخصصات",
  "open findings": "ملاحظات مفتوحة",
  "open work orders": "أوامر عمل مفتوحة",
  "Last inspected": "آخر فحص",
  "no work order yet": "لا أمر عمل بعد",
  "nothing found": "لم يُعثر على شيء",
  sample: "نموذجي",
  "Forecast: {recent} repairs in the last two years, {rate} a year, × {factor} for the condition, + {backlog} for open findings, at {avg} each = {budget}.":
    "التوقع: {recent} إصلاحات في آخر سنتين، {rate} في السنة، × {factor} للحالة، + {backlog} للملاحظات المفتوحة، بتكلفة {avg} لكل منها = {budget}.",
  "{n} repair on record|{n} repairs on record":
    "لا إصلاحات مسجلة|إصلاح واحد مسجل|إصلاحان مسجلان|{n} إصلاحات مسجلة|{n} إصلاحًا مسجلًا|{n} إصلاح مسجل",

  /* ── the catalogues ── */
  "Daily inspection": "فحص يومي",
  "Detailed inspection": "فحص تفصيلي",
  "Very good": "جيد جدًا",
  Fair: "مقبول",
  Poor: "ضعيف",
  "Very poor": "ضعيف جدًا",
  Civil: "مدني",
  "Electro-mechanical": "كهروميكانيكي",
  "Fire systems": "أنظمة الحريق",
  "Cleaning services": "خدمات النظافة",
  "Pest control": "مكافحة الآفات",

  Structure: "الهيكل",
  Finishes: "التشطيبات",
  "External works": "الأعمال الخارجية",
  "LV distribution": "توزيع الجهد المنخفض",
  "UPS and batteries": "مزود الطاقة غير المنقطعة والبطاريات",
  "Earthing and lightning protection": "التأريض والحماية من الصواعق",
  HVAC: "التكييف والتهوية",
  "Vertical transport": "النقل الرأسي",
  "Pumps and motors": "المضخات والمحركات",
  Controls: "أنظمة التحكم",
  "Detection and alarm": "الكشف والإنذار",
  Suppression: "الإطفاء",
  "Passive protection": "الحماية السلبية",
  "Means of escape": "وسائل الإخلاء",
  "Portable equipment": "المعدات المحمولة",
  "Potable water": "مياه الشرب",
  "Drainage and sewage": "الصرف والمجاري",
  "Chilled water network": "شبكة المياه المبردة",
  Metering: "العدادات",
  "Public areas": "المناطق العامة",
  "Back of house": "المناطق الخلفية",
  "High level and external": "المرتفعات والواجهات الخارجية",
  "Waste and performance": "النفايات والأداء",
  Rodents: "القوارض",
  Insects: "الحشرات",
  "Birds and wildlife": "الطيور والحياة البرية",
  Proofing: "العزل ضد الآفات",

  "External envelope and cladding free of visible damage": "الغلاف الخارجي والكسوة خاليان من أضرار ظاهرة",
  "No water ingress at roofs, gutters or ceilings": "لا تسرب مياه من الأسقف أو المزاريب أو الأسقف المعلقة",
  "Floors free of trip hazards, lifting or broken tiles": "الأرضيات خالية من مخاطر التعثر أو البلاط المرتفع أو المكسور",
  "Doors, shutters and windows open, close and lock": "الأبواب والمصاريع والنوافذ تُفتح وتُغلق وتُقفل",
  "Ceilings complete — no missing, stained or sagging tiles": "الأسقف مكتملة — لا بلاطات مفقودة أو ملطخة أو متدلية",
  "Drains, gullies and channels clear": "المصارف والبالوعات والقنوات نظيفة",
  "Signage and floor markings legible": "اللوحات وعلامات الأرضيات واضحة",
  "Slabs, beams and columns free of structural cracking": "البلاطات والجسور والأعمدة خالية من التشققات الإنشائية",
  "No spalling or exposed reinforcement": "لا تقشر للخرسانة ولا حديد تسليح مكشوف",
  "Expansion and movement joints intact and sealed": "فواصل التمدد والحركة سليمة ومحكمة",
  "No sign of settlement or differential movement": "لا علامات هبوط أو حركة تفاضلية",
  "Roof membrane and flashings intact": "غشاء السقف وألواح الحماية سليمة",
  "Curtain wall and cladding sealants sound": "مواد إحكام الواجهات الزجاجية والكسوة سليمة",
  "Glazing unbroken and gaskets in place": "الزجاج غير مكسور والجوانات في مكانها",
  "Basement and below-ground waterproofing dry": "عزل القبو وما تحت الأرض جاف",
  "Floor finishes sound and level": "تشطيبات الأرضيات سليمة ومستوية",
  "Wall finishes and paint in good order": "تشطيبات الجدران والدهان في حالة جيدة",
  "Suspended ceilings complete and level": "الأسقف المعلقة مكتملة ومستوية",
  "Handrails and balustrades secure": "الدرابزين والحواجز ثابتة",
  "Paving and kerbs level and unbroken": "الرصف والأرصفة مستوية وغير مكسورة",
  "Manholes and covers seated and intact": "غرف التفتيش وأغطيتها مثبتة وسليمة",
  "Fences and gates sound and secure": "الأسوار والبوابات سليمة ومؤمنة",
  "Car park and road markings legible": "علامات المواقف والطرق واضحة",
  "Lighting working in all public and plant areas": "الإنارة تعمل في كل المناطق العامة وغرف المعدات",
  "Panels closed, locked and labelled": "اللوحات مغلقة ومقفلة ومعلّمة",
  "No overheating, burning smell or noise at switchgear": "لا ارتفاع حرارة أو رائحة احتراق أو ضجيج في المفاتيح الكهربائية",
  "UPS in normal mode, no alarms": "مزود الطاقة غير المنقطعة في الوضع العادي بلا إنذارات",
  "Emergency lighting indicators healthy": "مؤشرات إنارة الطوارئ سليمة",
  "No exposed cables or damaged sockets": "لا كابلات مكشوفة أو مقابس تالفة",
  "Standby generator in auto, no alarms": "المولد الاحتياطي في الوضع الآلي بلا إنذارات",
  "Thermographic survey of panels shows no hot spots": "المسح الحراري للوحات لا يظهر نقاطًا ساخنة",
  "Breakers and protection settings as designed": "القواطع وإعدادات الحماية مطابقة للتصميم",
  "Cable trays and containment secure": "حوامل الكابلات ومساراتها مثبتة",
  "Circuit schedules current and posted": "جداول الدوائر محدثة ومعلقة",
  "Generator load test passed": "نجح اختبار تحميل المولد",
  "Fuel level and fuel quality acceptable": "مستوى الوقود وجودته مقبولان",
  "Starter batteries and charger healthy": "بطاريات التشغيل والشاحن سليمة",
  "Automatic changeover tested": "اختُبر التحويل الآلي",
  "UPS load within rating": "حمل مزود الطاقة ضمن السعة",
  "Battery autonomy test passed": "نجح اختبار مدة تشغيل البطاريات",
  "Battery room ventilation and temperature normal": "تهوية غرفة البطاريات وحرارتها طبيعية",
  "Internal lighting levels adequate": "مستويات الإنارة الداخلية كافية",
  "External and car park lighting working": "الإنارة الخارجية وإنارة المواقف تعمل",
  "Emergency lighting duration test passed": "نجح اختبار مدة إنارة الطوارئ",
  "Earth resistance within limit": "مقاومة التأريض ضمن الحد",
  "Lightning protection down conductors intact": "موصلات الحماية من الصواعق سليمة",
  "Equipotential bonding in place": "ربط تساوي الجهد موجود",
  "Space temperatures within the set range": "درجات حرارة الأماكن ضمن النطاق المحدد",
  "Air handling units running without abnormal noise or vibration": "وحدات مناولة الهواء تعمل دون ضجيج أو اهتزاز غير طبيعي",
  "Chillers and pumps running, no alarms": "المبردات والمضخات تعمل بلا إنذارات",
  "Lifts in service": "المصاعد في الخدمة",
  "Escalators and travelators in service": "السلالم والممرات المتحركة في الخدمة",
  "No visible leaks from pipework or units": "لا تسربات ظاهرة من الأنابيب أو الوحدات",
  "Building management system free of active alarms": "نظام إدارة المبنى خالٍ من الإنذارات النشطة",
  "Filters clean or replaced to schedule": "المرشحات نظيفة أو مستبدلة حسب الجدول",
  "Coils clean and fins undamaged": "الملفات نظيفة والزعانف سليمة",
  "Belts, couplings and bearings in good condition": "السيور والوصلات والمحامل في حالة جيدة",
  "Dampers and actuators working": "المخمدات والمشغلات تعمل",
  "Refrigerant charge and pressures normal": "شحنة غاز التبريد والضغوط طبيعية",
  "Lift brakes, doors and safety gear tested": "اختُبرت مكابح المصاعد وأبوابها ومعدات السلامة",
  "Lift emergency phone and alarm working": "هاتف الطوارئ وإنذار المصعد يعملان",
  "Escalator steps, comb plates and handrails sound": "درجات السلالم المتحركة وألواح المشط والدرابزين سليمة",
  "Vibration within limits": "الاهتزاز ضمن الحدود",
  "Seals and glands not leaking": "موانع التسرب لا تسرّب",
  "Motor insulation resistance acceptable": "مقاومة عزل المحرك مقبولة",
  "Sensors reading true against a reference": "الحساسات تقرأ بدقة مقارنة بمرجع",
  "Setpoints and schedules as agreed": "نقاط الضبط والجداول كما اتُّفق",
  "Conveyor belts and rollers in good condition": "سيور النقل والبكرات في حالة جيدة",
  "Drives and gearboxes quiet and cool": "المحركات وصناديق التروس هادئة وباردة",
  "Emergency stops tested": "اختُبرت مفاتيح الإيقاف الطارئ",
  "Fire alarm panel normal, no faults or disablements": "لوحة إنذار الحريق طبيعية بلا أعطال أو تعطيلات",
  "Extinguishers present, tagged and in date": "الطفايات موجودة ومعلّمة وصالحة",
  "Escape routes and exits clear": "مسارات الإخلاء والمخارج خالية",
  "Fire doors closed and not wedged": "أبواب الحريق مغلقة وغير مثبتة مفتوحة",
  "Sprinkler valves open and secured": "صمامات الرشاشات مفتوحة ومؤمنة",
  "Hose reels accessible": "بكرات الخراطيم يمكن الوصول إليها",
  "Detectors tested — sample for this quarter": "اختُبرت الكواشف — عينة هذا الربع",
  "Sounders and beacons audible and visible": "أجهزة الصوت والإشارات الضوئية مسموعة ومرئية",
  "Panel batteries and charger healthy": "بطاريات اللوحة والشاحن سليمة",
  "Cause and effect tested": "اختُبرت مصفوفة السبب والنتيجة",
  "Sprinkler flow test passed": "نجح اختبار تدفق الرشاشات",
  "Fire pumps start automatically": "مضخات الحريق تعمل آليًا",
  "System pressures normal": "ضغوط النظام طبيعية",
  "Gas suppression in server rooms charged": "نظام الإطفاء بالغاز في غرف الخوادم مشحون",
  "Fire door closers and seals working": "مغلقات أبواب الحريق وموانعها تعمل",
  "Compartment penetrations sealed": "فتحات العبور بين الحجرات محكمة",
  "Fire dampers tested": "اختُبرت مخمدات الحريق",
  "Exit signs illuminated": "لوحات المخارج مضاءة",
  "Assembly points marked and clear": "نقاط التجمع معلّمة وخالية",
  "Extinguisher service dates current": "تواريخ صيانة الطفايات سارية",
  "Fire blankets and hose reels serviced": "بطانيات الحريق وبكرات الخراطيم مصانة",
  "Water pressure normal": "ضغط المياه طبيعي",
  "Tank levels within range": "مستويات الخزانات ضمن النطاق",
  "Pumps running, no leaks": "المضخات تعمل بلا تسربات",
  "Sewage treatment process normal, no odour": "عملية معالجة الصرف طبيعية بلا روائح",
  "Chilled water supply temperature normal": "حرارة إمداد المياه المبردة طبيعية",
  "No visible leaks on networks": "لا تسربات ظاهرة في الشبكات",
  "Meters read and recorded": "قُرئت العدادات وسُجلت",
  "Tanks clean and covered": "الخزانات نظيفة ومغطاة",
  "Chlorine residual within range": "الكلور المتبقي ضمن النطاق",
  "Backflow devices tested": "اختُبرت أجهزة منع الارتداد",
  "Hot and cold temperatures safe for legionella control": "درجات حرارة الماء الساخن والبارد آمنة للوقاية من الليجيونيلا",
  "Lift stations working, no alarms": "محطات الرفع تعمل بلا إنذارات",
  "Manholes and interceptors clear": "غرف التفتيش والمصائد نظيفة",
  "Treatment aeration and clarifiers working": "التهوية وأحواض الترسيب تعمل",
  "Effluent quality within consent": "جودة المياه المعالجة ضمن الترخيص",
  "Valves operable": "الصمامات قابلة للتشغيل",
  "Pipe insulation intact": "عزل الأنابيب سليم",
  "Distribution pumps healthy": "مضخات التوزيع سليمة",
  "Meters working and read remotely": "العدادات تعمل وتُقرأ عن بعد",
  "Consumption consistent with last period": "الاستهلاك متسق مع الفترة السابقة",
  "Public areas clean": "المناطق العامة نظيفة",
  "Toilets clean and stocked": "دورات المياه نظيفة ومزودة",
  "Waste bins emptied": "حاويات النفايات مفرغة",
  "Spills attended and wet-floor signs in place": "عولجت الانسكابات ووُضعت لوحات الأرضية المبللة",
  "Gate areas and seating clean": "مناطق البوابات والمقاعد نظيفة",
  "Prayer rooms clean": "المصليات نظيفة",
  "Carpets and mats clean": "السجاد والحصائر نظيفة",
  "High-traffic floors deep cleaned to schedule": "الأرضيات كثيفة الحركة منظفة تنظيفًا عميقًا حسب الجدول",
  "Seating and fixtures clean": "المقاعد والتجهيزات نظيفة",
  "Glazing clean inside": "الزجاج نظيف من الداخل",
  "Deep clean to schedule": "تنظيف عميق حسب الجدول",
  "Consumables stocked": "المستهلكات متوفرة",
  "Fixtures clean and working": "التجهيزات نظيفة وتعمل",
  "Offices and staff areas clean": "المكاتب ومناطق الموظفين نظيفة",
  "Stores and plant rooms tidy": "المخازن وغرف المعدات مرتبة",
  "High-level surfaces and fittings clean": "الأسطح والتركيبات المرتفعة نظيفة",
  "External glazing clean": "الزجاج الخارجي نظيف",
  "Waste segregated and removed on time": "النفايات مفروزة ومزالة في الوقت",
  "Response times met": "أزمنة الاستجابة محققة",
  "Complaints closed within the agreed time": "الشكاوى مغلقة ضمن الوقت المتفق عليه",
  "No pest sightings reported": "لا مشاهدات آفات مبلغ عنها",
  "Bait stations present and intact": "محطات الطعوم موجودة وسليمة",
  "Insect light traps working": "مصائد الحشرات الضوئية تعمل",
  "No evidence in food areas": "لا آثار في مناطق الطعام",
  "Doors, screens and strip curtains proofed": "الأبواب والشبك والستائر الشريطية محكمة",
  "Waste areas clean and closed": "مناطق النفايات نظيفة ومغلقة",
  "Bait stations inspected and counted": "فُحصت محطات الطعوم وعُدّت",
  "No activity or droppings found": "لا نشاط ولا فضلات",
  "External perimeter stations intact": "محطات المحيط الخارجي سليمة",
  "Insect light trap tubes and catch trays serviced": "صيانة أنابيب مصائد الحشرات الضوئية وصواني الالتقاط",
  "No crawling insect activity": "لا نشاط للحشرات الزاحفة",
  "Bird proofing — nets and spikes — intact": "وسائل منع الطيور — الشباك والأشواك — سليمة",
  "No nests in or near the building": "لا أعشاش داخل المبنى أو قربه",
  "Airside attractants removed": "أزيلت عوامل الجذب في جانب الطيران",
  "Gaps and openings sealed": "الفجوات والفتحات محكمة",
  "Drain covers and door sweeps in place": "أغطية المصارف ومانعات أسفل الأبواب في مكانها",
  "Treatments logged": "المعالجات مسجلة",
  "Only approved chemicals used, with safety data sheets on site": "تُستخدم مواد معتمدة فقط، مع صحائف بيانات السلامة في الموقع",

  "Concrete repair": "إصلاح الخرسانة",
  "Crack injection": "حقن الشقوق",
  "Roof waterproofing": "عزل السطح",
  "Sealant replacement": "استبدال مواد الإحكام",
  "Flooring repair": "إصلاح الأرضيات",
  "Ceiling repair": "إصلاح الأسقف",
  Painting: "الدهان",
  "Door and hardware repair": "إصلاح الأبواب وملحقاتها",
  "Drainage clearing": "تسليك الصرف",
  "Paving repair": "إصلاح الرصف",
  "Breaker replacement": "استبدال القاطع",
  "Cable repair": "إصلاح الكابلات",
  "Luminaire replacement": "استبدال وحدات الإنارة",
  "Termination tightening": "شد التوصيلات",
  "UPS battery replacement": "استبدال بطاريات مزود الطاقة",
  "Generator service": "صيانة المولد",
  "Earthing repair": "إصلاح التأريض",
  "Panel repair": "إصلاح اللوحة",
  "Filter replacement": "استبدال المرشحات",
  "Belt replacement": "استبدال السيور",
  "Refrigerant recharge": "إعادة شحن غاز التبريد",
  "Motor or bearing replacement": "استبدال المحرك أو المحمل",
  "Lift door repair": "إصلاح باب المصعد",
  "Escalator repair": "إصلاح السلم المتحرك",
  "Controls calibration": "معايرة أنظمة التحكم",
  "Pump seal replacement": "استبدال مانع تسرب المضخة",
  "Conveyor repair": "إصلاح السير الناقل",
  "Detector replacement": "استبدال الكاشف",
  "Sprinkler head replacement": "استبدال رأس الرشاش",
  "Fire pump repair": "إصلاح مضخة الحريق",
  "Door closer or seal repair": "إصلاح مغلق الباب أو مانعه",
  "Penetration sealing": "إحكام فتحات العبور",
  "Extinguisher service": "صيانة الطفايات",
  "Damper repair": "إصلاح المخمد",
  "Pipe leak repair": "إصلاح تسرب الأنابيب",
  "Valve replacement": "استبدال الصمام",
  "Pump repair": "إصلاح المضخة",
  "Tank cleaning": "تنظيف الخزان",
  "Blockage clearing": "إزالة الانسداد",
  "Insulation repair": "إصلاح العزل",
  "Meter replacement": "استبدال العداد",
  "Chemical dosing adjustment": "ضبط جرعات المواد الكيميائية",
  "Deep clean": "تنظيف عميق",
  "Carpet shampoo": "غسيل السجاد",
  "Glazing clean": "تنظيف الزجاج",
  "High-level clean": "تنظيف المرتفعات",
  "Consumables restock": "إعادة تعبئة المستهلكات",
  "Waste removal": "إزالة النفايات",
  "Stain removal": "إزالة البقع",
  "Re-clean": "إعادة التنظيف",
  "Bait replacement": "استبدال الطعوم",
  "Insect trap tube replacement": "استبدال أنابيب مصائد الحشرات",
  "Proofing repair": "إصلاح العزل ضد الآفات",
  Treatment: "معالجة",
  "Bird proofing repair": "إصلاح وسائل منع الطيور",
  "Nest removal": "إزالة الأعشاش",
  Fumigation: "تبخير",

  /* ── the menu ── */
  "Every facility inspected by each trade — civil, electrical, electro-mechanical, fire systems, utilities, cleaning and pest control — through its own contractor, on a short daily round or a detailed inspection; defects raised as work orders in the shared register, repairs compared year on year and by type, next year's cost forecast, and short or long reports to print.":
    "كل مرفق يفحصه كل تخصص — المدني والكهربائي والكهروميكانيكي وأنظمة الحريق والمرافق العامة والنظافة ومكافحة الآفات — عبر مقاوله، في جولة يومية قصيرة أو فحص تفصيلي؛ تُنشأ العيوب أوامر عمل في السجل المشترك، وتُقارن الإصلاحات سنة بسنة وحسب النوع، مع توقع تكلفة العام القادم، وتقارير قصيرة أو مطولة للطباعة.",
};
export default ar;
